import React from 'react';

import { DataTable, cn } from '@column/ui';

import { PAGE_SIZE_OPTIONS } from '~/stores/Config';

export interface PaginationProps {
  pageSize: number;
  onPageSizeChange: (value: number) => void;
  current: number;
  hasPrevious: boolean;
  hasNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
  className?: string;
}

export const Pagination: React.FC<PaginationProps> = ({
  pageSize,
  onPageSizeChange,
  current,
  hasPrevious,
  hasNext,
  onPrevious,
  onNext,
  className,
}) => (
  <DataTable.Pagination
    className={cn('relative z-[1] items-center pt-4', className)}
    pageIndex={current - 1}
    pageSize={Number(pageSize)}
    pageSizeOptions={PAGE_SIZE_OPTIONS}
    hasNext={hasNext}
    hasPrevious={hasPrevious}
    onNext={onNext}
    onPrevious={onPrevious}
    onPageSizeChange={onPageSizeChange}
  />
);
